import { Box, Button, Flex, HStack, Spacer, Stack, VStack } from '@chakra-ui/react';
import NiceModal from '@ebay/nice-modal-react';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import AlertModal from '../../components/modals/AlertModal';
import { displayRow } from '../../helpers/general';
import useDeleteChainMutation from '../../hooks/mutations/useDeleteChainMutation';
import useChainQuery from '../../hooks/useChainQuery';
import { ContentCard } from '../../layout/ContentCard';

const ChainDetailsSummaryCard = (props: { chainId: number }) => {
  const { chainId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const chainQuery = useChainQuery(chainId);
  const deleteChainMutation = useDeleteChainMutation(useChainQuery.getKey(chainId));

  if (chainQuery.isLoading) {
    return <LoadingSpinner />;
  }
  //TODO add status tag to card content

  // @ts-ignore
  return (
    <ContentCard isLoading={chainQuery.isFetching} header={`${t('pages:chains.details.summary.title')} ${chainQuery.data?.name}`}>
      <Stack w={'100%'} spacing={2} data-test-id="service-history-information">
        <HStack>
          <VStack>
            <Box>
              {displayRow({
                label: t('common:country'),
                content: t(`location:countries.${get(chainQuery.data, 'country')}`),
                isLoading: chainQuery.isFetching,
              })}
              {displayRow({
                label: t('common:language'),
                content: t(`location:languages.${get(chainQuery.data, 'language')}`),
                isLoading: chainQuery.isFetching,
              })}
              {displayRow({
                label: t('chains:billing_email.label'),
                content: get(chainQuery.data, 'billing_email'),
                isLoading: chainQuery.isFetching,
              })}
              {displayRow({
                label: t('chains:address.label'),
                content: get(chainQuery.data, 'address'),
                isLoading: chainQuery.isFetching,
              })}
              {displayRow({
                label: t('chains:city.label'),
                content: get(chainQuery.data, 'city'),
                isLoading: chainQuery.isFetching,
              })}
              {displayRow({
                label: t('chains:zipcode.label'),
                content: get(chainQuery.data, 'zipcode'),
                isLoading: chainQuery.isFetching,
              })}
              {displayRow({
                label: t('chains:vat_number.label'),
                content: get(chainQuery.data, 'vat_number'),
                isLoading: chainQuery.isFetching,
              })}
              {displayRow({
                label: t('chains:telephone.label'),
                content: get(chainQuery.data, 'telephone'),
                isLoading: chainQuery.isFetching,
              })}
            </Box>
          </VStack>
          <Spacer />
          <Flex>
            <Box mt={'90%'}>
              <Button
                mr={'5px'}
                width={'80px'}
                alignSelf={'right'}
                color={'red.600'}
                borderColor={'red.600'}
                //@ts-ignore
                _hover={'pink.600'}
                variant="outline"
                onClick={() => {
                  NiceModal.show(AlertModal, {
                    onSubmit: () =>
                      deleteChainMutation.mutateAsync(chainId).then(() => {
                        navigate(`/app/op/chains`);
                      }),
                    children: t('pages:chains.delete.message'),
                    content: {
                      header: t('pages:chains.delete.title'),
                      footer: {
                        buttons: {
                          cancelCaption: t('common:cancel'),
                          actionCaption: t('common:delete'),
                        },
                      },
                    },
                  });
                }}
              >
                {t('common:delete')}
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  navigate(`/app/op/chains/${chainId}/update`);
                }}
              >
                {t('common:update')}
              </Button>
            </Box>
          </Flex>
        </HStack>
      </Stack>
    </ContentCard>
  );
};

export default ChainDetailsSummaryCard;
